'use client';
import React from 'react';

const footerLinks = [
  {
    title: 'Company',
    links: [
      { label: 'About Us', href: '#about' },
      { label: 'Our Story', href: '#our-story' },
      { label: 'Why Choose Us', href: '#why-choose' },
      { label: 'Awards & Recognition', href: '#recognitions' },
      { label: 'Featured Articles', href: '#blogs' },
    ],
  },
  {
    title: 'Projects',
    links: [
      { label: 'New Projects (Upcoming)', href: '#' },
      { label: 'Completed Projects', href: '#' },
      { label: 'Plot Development', href: '#projects' },
    ],
  },
  {
    title: 'Investment',
    links: [
      { label: 'HNI Investment Plans', href: '#' },
      { label: 'Wealth Growth Plans', href: '#' },
      { label: 'Real Estate Advisory', href: '#' },
      { label: 'Portfolio Management', href: '#' },
    ],
  },
  {
    title: 'Career',
    links: [
      { label: 'Career Opportunities', href: '#' },
    ],
  },
  {
    title: 'Others',
    links: [
      { label: 'Blogs', href: '#blogs' },
      { label: "FAQ\'s", href: '#' },
      { label: 'Terms & Conditions', href: '#' },
      { label: 'Privacy Policy', href: '#' },
      { label: 'Disclaimer', href: '#' },
      { label: 'Contact Us', href: '#contact' },
    ],
  },
];

const socialLinks = [
  { label: 'Facebook', href: '#', icon: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z' },
  { label: 'Instagram', href: '#', icon: 'M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01M6.5 19.5h11a3 3 0 003-3v-11a3 3 0 00-3-3h-11a3 3 0 00-3 3v11a3 3 0 003 3z' },
  { label: 'Twitter', href: '#', icon: 'M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z' },
  { label: 'LinkedIn', href: '#', icon: 'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 6a2 2 0 100-4 2 2 0 000 4z' },
  { label: 'YouTube', href: '#', icon: 'M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z' },
];

export default function Footer() {
  return (
    <footer id="contact" className="bg-brand-dark text-white">
      <div className="container mx-auto px-4 py-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            {/* Logo */}
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/ChatGPT_Image_Aug_8__2026__05_21_44_PM-1786189960912.png"
                alt="Neo Capital Group Logo"
                className="h-12 w-auto object-contain"
              />
              <span className="text-brand-turmeric font-bold font-avenir text-base tracking-wide leading-tight">Neo Capital Group</span>
            </div>

            <hr className="border-white/20 my-4" />

            <p className="text-white/70 font-avenir text-xs leading-relaxed mb-6">
              Neo Capital Group is your trusted partner in premium plot development and real estate — committed to transparency, legal compliance, and long-term value creation for families and investors across India.
            </p>

            <h6 className="text-white font-semibold font-avenir text-sm mb-3">Connect With Us</h6>
            <div className="flex gap-3">
              {socialLinks?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.href}
                  aria-label={social?.label}
                  className="w-8 h-8 rounded-full bg-white/10 hover:bg-brand-turmeric flex items-center justify-center transition-colors duration-200"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d={social?.icon} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks?.map((col) => (
            <div key={col?.title} className="lg:col-span-1">
              <h5 className="text-brand-turmeric-light font-bold font-avenir text-sm mb-4 uppercase tracking-wide">
                {col?.title}
              </h5>
              <ul className="space-y-2">
                {col?.links?.map((link) => (
                  <li key={link?.label}>
                    <a
                      href={link?.href}
                      className="text-white/60 font-avenir text-xs hover:text-brand-turmeric-light transition-colors duration-200"
                    >
                      {link?.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Download Apps + Contact */}
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-bold font-avenir text-sm mb-1">Download Our Apps</h3>
            <p className="text-white/50 font-avenir text-xs mb-3">Created for convenience and ease to make it memorable</p>
            <div className="flex gap-3">
              <a href="#" className="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors duration-200">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <span className="text-white font-avenir text-xs">App Store</span>
              </a>
              <a href="#" className="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors duration-200">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M3.18 23.76c.3.17.65.19.97.07l12.43-7.18-2.63-2.63-10.77 9.74zM.5 1.48C.19 1.79 0 2.28 0 2.91v18.18c0 .63.19 1.12.5 1.43l.07.07 10.18-10.18v-.24L.57 1.41.5 1.48zM20.49 10.34l-2.9-1.68-2.93 2.93 2.93 2.93 2.91-1.68c.83-.48.83-1.26-.01-1.5zM3.18.24L15.95 7.6l-2.63 2.63L.75.17C1.07.05 1.42.07 1.72.24l1.46.84V.24z" />
                </svg>
                <span className="text-white font-avenir text-xs">Google Play</span>
              </a>
            </div>
          </div>

          <a
            href="#contact"
            className="px-8 py-3 bg-brand-turmeric text-white font-semibold rounded-lg font-avenir text-sm hover:bg-brand-turmeric-light transition-colors duration-200"
          >
            Contact us
          </a>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="bg-black/30">
        <div className="container mx-auto px-4 py-4 max-w-7xl">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="flex gap-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.href}
                  aria-label={social?.label}
                  className="w-7 h-7 rounded-full bg-white/10 hover:bg-brand-turmeric flex items-center justify-center transition-colors duration-200"
                >
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d={social?.icon} />
                  </svg>
                </a>
              ))}
            </div>
            <p className="text-white/50 font-avenir text-xs">
              Copyright 2025 &copy; Neo Capital Group. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
